export default class Config {
  static getAllPagesConfig() {
    return new Promise((resolve) => {
      const appConfig = this.getPageConfig("app", "./config/AppConfig.json");
      const overview = this.getPageConfig(
        "overview",
        "./config/PagesConfig/Overview.json"
      );
      const opportunities = this.getPageConfig(
        "opportunities",
        "./config/PagesConfig/Opportunities.json"
      );
      const deatil = this.getPageConfig(
        "detail",
        "./config/PagesConfig/Detail.json"
      );

      Promise.all([appConfig, overview, opportunities, deatil]).then(
        (values) => {
          const config = {};
          for (let i = 0; i < values.length; i += 1) {
            const item = values[i];
            config[item.configName] = item;
          }
          resolve(config);
        }
      );
    });
  }

  static getPageConfig(name, path) {
    return new Promise((resolve) => {
      fetch(path).then((response) => {
        response.json().then((res) => {
          const data = res;
          data.configName = name;
          resolve(data);
        });
      });
    });
  }
}
